export default "__VITE_ASSET__DNiFpR$i__"